import { computed, ref } from 'vue';

/**
 * A composable for image validation
 * @param {object} options
 * @param {import('vue').Ref<String | null>} options.imageUrl - image url
 */
export default function useImageValidation({
  imageUrl = ref(''),
}) {
  const hasError = ref(null);

  const onImageUrlError = () => {
    // set hasError to true if img cannot load and returns an error
    hasError.value = true;
  };

  /**
   * Check if image is valid URL.
   *
   * @returns {boolean} true if URL is valid.
   */
  const isImage = () => {
    // url pattern check checks for valid local images
    // URL() constructor checks for valid URLs
    // if URL is not valid, throws TypeError exception and returns false
    if (imageUrl.value.toLowerCase().startsWith('/')) {
      return true;
    }
    try {
      return Boolean(new URL(imageUrl.value));
    } catch (e) {
      return false;
    }
  };

  const isValidImageUrl = computed(() => imageUrl.value !== '' && isImage());

  return {
    hasError, onImageUrlError, isValidImageUrl,
  };
}
